module.exports = __webpack_public_path__ + "static/media/09.e6030cdb.svg";